import cls from "classnames";
import React, { useRef, useState } from "react";

export default function TextAreaField(props) {
  const {
    name,
    placeholder,
    primaryColor,
    value,
    onChange,
    autoComplete,
    required,
    disabled,
    autoFocus,
    onBlur,
  } = props;

  const textAreaRef = useRef(null);

  const [isFocused, setIsFocused] = useState();

  function resize() {
    if (textAreaRef && textAreaRef.current) {
      textAreaRef.current.style.minHeight = "auto";

      const height = textAreaRef.current.scrollHeight;

      textAreaRef.current.style.minHeight = `${height}px`;
    }
  }

  const _onBlur = (e) => {
    setIsFocused(false);
    onBlur && onBlur(e);
  };

  const _onFocus = (e) => {
    setIsFocused(true);
  };

  const _onChange = (e) => {
    resize();

    onChange && onChange(e);
  };

  return (
    <textarea
      style={{
        borderColor: isFocused ? primaryColor : "#D5D8DC",
        overflowY: "hidden",
        resize: "none",
      }}
      className={cls(
        "w-full bg-transparent text-sm flex-1 min-w-0 border rounded p-3",
        "placeholder-[#22272B] placeholder-opacity-20",
        "outline-none focus:outline-none disabled:cursor-not-allowed"
      )}
      ref={textAreaRef}
      name={name}
      autoFocus={autoFocus}
      onChange={_onChange}
      autoComplete={autoComplete}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onFocus={_onFocus}
      onBlur={_onBlur}
    ></textarea>
  );
}
